import { NgModule } from '@angular/core';
import { LayoutModule } from '../../layout/layout.module';
import { ComponentsModule } from '../../components/components.module';

import { RecursosHumanosRoutingModule } from './recursos-humanos-routing.module';
import { GestaoPerfisComponent } from './gestao-perfis/gestao-perfis.component';
import { CriarPerfilComponent } from './criar-perfil/criar-perfil.component';
import { GestaoAcessoComponent } from './gestao-acesso/gestao-acesso.component';
import { CriarUsuarioComponent } from './criar-usuario/criar-usuario.component';
import { DashboardRhComponent } from './dashboard-rh/dashboard-rh.component';
import { FrenteTrabalhoComponent } from './frente-trabalho/frente-trabalho.component';
import { ListagemFrenteTrabalhoComponent } from './listagem-frente-trabalho/listagem-frente-trabalho.component';
import { AssociarFrenteTrabalhoComponent } from './associar-frente-trabalho/associar-frente-trabalho.component';
import { CadastrarPessoaComponent } from './cadastrar-pessoa/cadastrar-pessoa.component';
import { ListagemPessoasComponent } from './listagem-pessoas/listagem-pessoas.component';
import { ListagemLicencasComponent } from './listagem-licencas/listagem-licencas.component';
import { RegistrarLicencaComponent } from './registrar-licenca/registrar-licenca.component';
import { AcrescimoComponent } from './acrescimo/acrescimo.component';
import { EditarAcrescimoComponent } from './editar-acrescimo/editar-acrescimo.component';

@NgModule({
  declarations: [
    GestaoPerfisComponent,
    CriarPerfilComponent,
    GestaoAcessoComponent,
    CriarUsuarioComponent,
    DashboardRhComponent,
    FrenteTrabalhoComponent,
    ListagemFrenteTrabalhoComponent,
    AssociarFrenteTrabalhoComponent,
    CadastrarPessoaComponent,
    ListagemPessoasComponent,
    ListagemLicencasComponent,
    RegistrarLicencaComponent,
    AcrescimoComponent,
    EditarAcrescimoComponent,
  ],
  imports: [RecursosHumanosRoutingModule, ComponentsModule, LayoutModule],
  exports: [],
})
export class RecursosHumanosModule {}
